module.exports = __webpack_public_path__ + "static/background-c8808c69958817582337e013deda3649.png";